import React, { useEffect } from 'react';
import 'react-table-6/react-table.css';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { Utils, Filters } from '../../../services';
import PageTitle from '../../../components/PageTitle/PageTitle';
import Table from '../../../components/Table';
import TableButtons from '../../../components/TableButtons';
import CreateButton from '../../../components/CreateButton';

import { loadApplicationTypes } from '../../../redux/modules/applicationTypes';

import './ApplicationTypesList.css';

const ApplicationTypesList = () => {
    const { t }        = useTranslation();
    const { application_types }  = useSelector(state => state.applicationTypes);
    const dispatch     = useDispatch();
    const default_lang = Utils.default_lang();

    useEffect(() => {
        dispatch(loadApplicationTypes());
    }, [dispatch]);

    const title = <span>{t("applicationTypes.applicationType", {count: 42})}</span>;

    const actions = <CreateButton module={`application_types`} text="applicationTypes.add" />;

    const columns = [{
        Header: t('applicationTypes.name'),
        accessor: "name",
        filterMethod: Filters.textFilterMethod("name." + default_lang),
        Filter: Filters.textFilter,
        filterAll: true,
        Cell: row => row.value && (
            <div className="name_cell">
                <Link to={`/application_types/edit/${row.original.id}`}>
                    {row.original.name[default_lang]}
                </Link>
            </div>
        )
    }, {
        Header: t('common.actions'),
        accessor: "id",
        maxWidth: 110,
        filterable: false,
        Cell: row => (
            <TableButtons
                id={row.value}
                actions={["edit", "delete"]}
                module="application_types"
            />
        )
    }];

    return (
        <div className="ApplicationTypesList">
            <PageTitle icon="address-book" title={title} actions={actions} />
            <Table id="applicationTypesTable" data={application_types} columns={columns} />
        </div>
    );
}

export default ApplicationTypesList;
